import React from 'react';
import { Link } from 'react-router-dom';
import IconDocumentStatus from "../partials/IconDocumentStatus";

class ConsultantItem extends React.Component {

  renderCircle() {

    return  <IconDocumentStatus style={{marginRight: "10px", height: "20px", width: "20px", display: "inline-block", marginTop: "5px"}}
                                  progression={this.props.progression}
                                  validationInformation={this.props.validationInformation}
                                  infovisible="false"
                                  kind="consultant"
                                  isincompleted={this.props.isincompleted}
                                  translate={this.props.translate}
              />  

  }


  render() {
   
    var title = this.props.name.firstName + ' ' + this.props.name.lastName
    if (title === "") {
      title = "(Sans titre)"
    }

    return (
      
      <li className="line">
        {!this.props.small && this.props.circle ? (
          <div className="line">
            <Link className="" to={"/consultant/" + this.props.id}>   
            <div className="line" style={{display:"inline-block", width:"auto"}}>{this.renderCircle()}</div>
            <div className="line" style={{display:"inline-block", width:"auto"}}>{title}</div>
            </Link>
          </div>
        ) : (
          null
        )}
      </li>
    );

  }
}

export default ConsultantItem;